<div class="loading-spinner">
  <mat-spinner></mat-spinner>
</div>
